import { useMemo } from "react";
import { getTokenValue } from "@tamagui/core";
import { BlurView } from "expo-blur";
import { jsx } from "react/jsx-runtime";
const BackgroundBlur = ({ blurRadius, ...props }) => {
  const intensity = useMemo(() => (typeof blurRadius == "number" ? blurRadius : getTokenValue(blurRadius, "backgroundBlur")) * 5, [blurRadius]);
  return /* @__PURE__ */ jsx(BlurView, { ...props, intensity });
};
export {
  BackgroundBlur
};
